import { useGame } from '../state/store'
import { setProgress } from '../engine/lexicon'
import { WORDS } from '../config/dictionary'
import { GLOBAL } from '../config/global'

export function Lexicon() {
  const lexicon = useGame((s) => s.lexicon)
  const collected = useGame((s) => s.collectedWords())
  const sets = setProgress(collected)

  const sorted = [...lexicon].sort((a, b) => a.word.localeCompare(b.word))

  return (
    <section className="rounded-lg border border-ink-border bg-ink-panel p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-xs font-bold uppercase tracking-widest text-ink-teal">
          Lexicon
        </h2>
        <span className="text-[10px] text-ink-muted">
          {lexicon.length} / {WORDS.length} discovered
        </span>
      </div>

      {/* Set collections */}
      <div className="mb-3 grid grid-cols-3 gap-2">
        {sets.map((s) => {
          const done = s.have === s.total
          return (
            <div
              key={s.id}
              className={`rounded-md border p-2 text-center text-[10px] ${
                done ? 'border-ink-teal text-ink-teal' : 'border-ink-border text-ink-muted'
              }`}
            >
              <div className="font-bold uppercase tracking-wider">{s.name}</div>
              <div className="tabular-nums">
                {s.have}/{s.total}
              </div>
            </div>
          )
        })}
      </div>

      {lexicon.length === 0 ? (
        <p className="text-xs text-ink-muted">
          No words yet. Spell one above using letters you own.
        </p>
      ) : (
        <div className="flex flex-wrap gap-1.5">
          {sorted.map((e) => (
            <span
              key={e.word}
              title={`Lv${e.level} · ${e.uses} uses${e.mastered ? ' · MASTERED' : ''}`}
              className={`chip px-2 py-1 text-xs ${
                e.mastered
                  ? 'border-rarity-legend text-rarity-legend'
                  : 'border-ink-border text-ink-text'
              }`}
            >
              {e.word}
              <span className="ml-1 text-[9px] text-ink-muted">
                {e.mastered ? '★' : `L${e.level}`}
              </span>
            </span>
          ))}
        </div>
      )}

      <p className="mt-3 text-[10px] text-ink-muted">
        Each craft levels a word (+{GLOBAL.wordLevelMultPerLevel * 100}% burst/level). Complete a
        set for a global bonus (max +{GLOBAL.setBonusTotalMax * 100}%).
      </p>
    </section>
  )
}
